export type ReportFontFamilyOption = Readonly<{ label: string; value: string }>;

export const DEFAULT_REPORT_FONT_FAMILY =
  '"proxima-nova", Helvetica, Arial, sans-serif';

export const REPORT_FONT_FAMILY_OPTIONS: ReadonlyArray<ReportFontFamilyOption> = [
  { label: 'Proxima Nova', value: DEFAULT_REPORT_FONT_FAMILY },
  { label: 'Inter', value: '"Inter", sans-serif' },
  { label: 'Roboto', value: '"Roboto", sans-serif' },
  { label: 'DM Sans', value: '"DM Sans", sans-serif' },
  { label: 'Nunito Sans', value: '"Nunito Sans", sans-serif' },
  { label: 'Lato', value: '"Lato", sans-serif' },
  { label: 'Merriweather', value: '"Merriweather", serif' },
  { label: 'Playfair Display', value: '"Playfair Display", serif' },
  { label: 'Libre Baskerville', value: '"Libre Baskerville", serif' },
  { label: 'JetBrains Mono', value: '"JetBrains Mono", monospace' },
  { label: 'Roboto Mono', value: '"Roboto Mono", monospace' },
];
